import React, { useState, useEffect } from "react";
import {
  editFooter,
  getFooter,
  getAllPages,
  createFooter,
  publishFooter,
  requestPublish,
} from "../../api/api";
import FooterList from "../list/footerList";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { NecStore } from "../../store/necStore";
import { UserLang, UserStore } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";

const ClientFooter = (props) => {
  const [list, setList] = useState([]);

  const [allPage, setallPage] = useState([]);
  const user = UserStore.useState((s) => s.user);
  const role = NecStore.useState((s) => s.setting);
  const lan = UserLang.useState((s) => s.lan);

  const page = {
    sectionHeader1: "",
    sectionHeader2: "",
    sectionHeader3: "",
    facebookLink: "",
    youtubeLink: "",
    instagramLink: "",
    twitterLink: "",
    items: list,
    footDescription: "",
  };
  const [foot, setFoot] = useState(page);
  const [footCount, setFootCount] = useState("");
  const [footStatus, setFootStatus] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const elementDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const pageid = props.match.params.id;
      const result = await getFooter(pageid).then(
        (result) => {
          setFoot(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setFootCount(obj.message);
          setFootStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };

    const getPaged = async () => {
      try {
        const appl = await getAllPages(200, 0);

        const pages = appl.data.pages;

        const imageCount = appl.data.count;

        const opt = pages.map((item) => ({
          value: item._id,
          label: item.referenceName,
        }));
        setallPage(opt);
      } catch (error) {}
    };
    /* eslint-disable no-unused-vars */
    elementDetail();
    getPaged();
    /* eslint-disable no-unused-vars */
  }, [props.match.params.id]);

  const setNotifications = async (editing) => {
    setLoading(true);
    /* eslint-disable no-unused-vars */
    // const pageid = props.match.params.id;
    const result = await requestPublish(editing).then(
      (result) => {
        toastr.success("Request Sent", "Success");

        // brandImage(result.data);
        // setPage(result.data);
        setLoading(false);
      },
      (error) => {
        toastr.error("Unable to Load Data", "Error");
        setLoading(false);
      }
    );
    /* eslint-disable no-unused-vars */
  };

  const handlePublishRequest = (evt) => {
    evt.preventDefault();

    const opt = {
      itemtype: null,
      itemid: null,
      redirect: "footer",
      message: "Content Editor requested to Publish Footer",
    };

    setNotifications(opt);
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setFoot({
      ...foot,
      [evt.target.name]: value,
    });
  };

  const draft = async (event) => {
    setLoading(true);
    event.preventDefault();
    if (footStatus === 404 || footCount === "No Footer Schema Exists") {
      /* eslint-disable no-unused-vars */
      const result = await createFooter(foot).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      const result = await editFooter(foot).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
  };

  const publish = async (event) => {
    // setDisable(true);
    if (role.production === true) {
      setLoading(true);
      event.preventDefault();

      /* eslint-disable no-unused-vars */
      const result = await publishFooter().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  const handleListChange = (edit) => {
    const opt = edit.map((item) => ({
      itemid: item.value,
      itemRef: item.label,
      itemOrder: item.order,
      itemSection: item.section,
      itemHeader: item.header,
    }));
    setList(opt);
    /*eslint-disable no-useless-computed-key */

    setFoot({
      ...foot,
      ["items"]: opt,
    });

    /*eslint-disable no-useless-computed-key */
  };
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Footer Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={draft}>
                    <div className="row">
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Display title in the footer first section"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;First Section Header&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Display title in the footer first section"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="sectionHeader1"
                            className="form-control inside-form"
                            placeholder="First Section Header ..."
                            defaultValue={foot.sectionHeader1}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Display title in the footer second section"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Second Section Header&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Display title in the footer second section"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="sectionHeader2"
                            className="form-control inside-form"
                            placeholder="Second Section Header ..."
                            defaultValue={foot.sectionHeader2}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Display title in the footer third section"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Third Section Header&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Display title in the footer third section"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="sectionHeader3"
                            className="form-control inside-form"
                            placeholder="Third Section Header ..."
                            defaultValue={foot.sectionHeader3}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Instagram Link
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="instagramLink"
                            className="form-control inside-form"
                            placeholder="Instagram Link"
                            defaultValue={foot.instagramLink}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Facebook Link
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="facebookLink"
                            className="form-control inside-form"
                            placeholder="Facebook Link"
                            defaultValue={foot.facebookLink}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Youtube Link
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="youtubeLink"
                            className="form-control inside-form"
                            placeholder="Youtube Link"
                            defaultValue={foot.youtubeLink}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        {/* text input */}
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {/* {(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                            Twitter Link
                            {/* &nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>} */}
                          </label>
                          <input
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            type="text"
                            name="twitterLink"
                            className="form-control inside-form"
                            placeholder="Twitter Link"
                            defaultValue={foot.twitterLink}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={"Intro description for the footer panel"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Footer Description&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={"Intro description for the footer panel"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <textarea
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            name="footDescription"
                            className="form-control inside-form"
                            placeholder="Footer Description"
                            defaultValue={foot.footDescription}
                            onChange={handleChange}
                            autoComplete="off"
                          ></textarea>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2 mt-2"></div>
                    <div className="card-header" style={{ padding: "0" }}>
                      <label
                        className={lan === "rtl" ? "float-right" : "float-left"}
                      >
                        {lan === "rtl" && (
                          <ToolTip
                            info={
                              "Select required footer available on the page"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                        &nbsp;Footer Items Container&nbsp;
                        {!(lan === "rtl") && (
                          <ToolTip
                            info={
                              "Select required footer available on the page"
                            }
                            place={lan === "rtl" ? "left" : "right"}
                          />
                        )}
                      </label>
                    </div>
                    <FooterList
                      dir={lan === "rtl" ? "rtl" : "ltr"}
                      data={allPage}
                      url={props.match.params.id}
                      onChange={handleListChange}
                      listData={foot.items}
                      {...props}
                    ></FooterList>

                    <div className="row mb-2 mt-2"></div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "btn-group btn-group-md float-left"
                              : "btn-group btn-group-md float-right"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                          {role.RFP === true && user.editor === true ? (
                            <button
                              type="#!"
                              onClick={handlePublishRequest}
                              className="btn btn-success"
                              style={{ width: "100px", marginRight: "6px" }}
                              disabled={
                                !role.production === true ? true : false
                              }
                              hidden={!role.production === true ? true : false}
                            >
                              Request to Publish
                            </button>
                          ) : (
                            <button
                              type="#!"
                              onClick={publish}
                              className="btn btn-success"
                              style={{ width: "100px", marginRight: "6px" }}
                              disabled={
                                !role.production === true ? true : false
                              }
                              hidden={!role.production === true ? true : false}
                            >
                              Publish
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default ClientFooter;
